// extracted by mini-css-extract-plugin
export default {"btn":"FavoritesOnlyChip_btn__JBHEY","on":"FavoritesOnlyChip_on__8+SKo","icon":"FavoritesOnlyChip_icon__u89q4"};